export const apiPath = "/api-cms";

//Layout
export const headerApiPath = "/overall-header";
export const footerApiPath = "/footer";

export const homePageApiPath = "/home-page";
export const globalSearchApiPath = "/home-page/search-results";
export const organizationApiPath = "/categories";
export const charitableTrustApiPath = "/charitabletrusts";
export const hamaaraSapnaApiPath = "/hamara-sapna";
export const initiativeClassificationApiPath = "/initiative-categories";
export const initiativeApiPath = "/services";
export const newsAndMediaPageApiPath = "/news-media/news-mediapage";
export const allNewsApiPath = "/allnews";
export const successStoriesApiPath = "/success-stories";
export const keyHighlightsApiPath = "/timelines";
export const partnersApiPath = "/partners";
export const caseStudiesApiPath = "/case-studies";
export const contactUsApiPath = "/contact-page";
export const ourLegacyApiPath = "/our-legacy";
export const wardhaApiPath = "/wardha";
export const awardsApiPath = "/awards-page";
export const aboutUsApiPath = "/about-us";
export const caseStudiesByCompanyApiPath =
  "/case-studies?filters[company][slug][$eq]=";
export const termsAndConditionsApiPath = "/terms-and-condition";
export const privacyPolicyApiPath = "/privacy-policy";
export const disclaimerApiPath = "/disclaimer";
